import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    fetchMemberRecords(ctx, params = {}) {
      return new Promise((resolve, reject) => {
        const queryParams = new URLSearchParams()
        
        if (params.page) queryParams.append('page', params.page)
        if (params.limit) queryParams.append('limit', params.limit)
        if (params.search) queryParams.append('search', params.search)
        if (params.courseName) queryParams.append('courseName', params.courseName)
        if (params.departmentName) queryParams.append('departmentName', params.departmentName)
        if (params.userName) queryParams.append('userName', params.userName)
        if (params.examStatus !== undefined && params.examStatus !== null) {
          queryParams.append('examStatus', params.examStatus)
        }
        if (params.courseStatus !== undefined && params.courseStatus !== null) {
          queryParams.append('courseStatus', params.courseStatus)
        }
        if (params.startDate) queryParams.append('startDate', params.startDate)
        if (params.endDate) queryParams.append('endDate', params.endDate)
        if (params.unit) queryParams.append('unit', params.unit)
        if (params.subunit) queryParams.append('subunit', params.subunit)
        
        const url = `/lms/admin/course/getUserLearningRecords${queryParams.toString() ? '?' + queryParams.toString() : ''}`
        
        axios
          .get(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchDistinctCourseNames(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/lms/admin/course/getDistinctCourseNames`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchDistinctDepartments(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/lms/admin/course/getDistinctDepartments`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchDistinctUnits(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/lms/admin/course/getDistinctUnits`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchDistinctSubunits(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/lms/admin/course/getDistinctSubunits`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchStatistics(ctx, params = {}) {
      return new Promise((resolve, reject) => {
        const queryParams = new URLSearchParams()
        
        // Pagination parametreleri YOK - sadece filtreler
        if (params.search) queryParams.append('search', params.search)
        if (params.courseName) queryParams.append('courseName', params.courseName)
        if (params.departmentName) queryParams.append('departmentName', params.departmentName)
        if (params.userName) queryParams.append('userName', params.userName)
        if (params.examStatus !== undefined && params.examStatus !== null) {
          queryParams.append('examStatus', params.examStatus)
        }
        if (params.courseStatus !== undefined && params.courseStatus !== null) {
          queryParams.append('courseStatus', params.courseStatus)
        }
        if (params.startDate) queryParams.append('startDate', params.startDate)
        if (params.endDate) queryParams.append('endDate', params.endDate)
        if (params.unit) queryParams.append('unit', params.unit)
        if (params.subunit) queryParams.append('subunit', params.subunit)
        
        const url = `/lms/admin/course/getUserLearningRecords/statistics${queryParams.toString() ? '?' + queryParams.toString() : ''}`
        
        axios
          .get(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchExportData(ctx, params = {}) {
      return new Promise((resolve, reject) => {
        const queryParams = new URLSearchParams()
        
        // Pagination parametreleri YOK - sadece filtreler
        if (params.search) queryParams.append('search', params.search)
        if (params.courseName) queryParams.append('courseName', params.courseName)
        if (params.departmentName) queryParams.append('departmentName', params.departmentName)
        if (params.userName) queryParams.append('userName', params.userName)
        if (params.examStatus !== undefined && params.examStatus !== null) {
          queryParams.append('examStatus', params.examStatus)
        }
        if (params.courseStatus !== undefined && params.courseStatus !== null) {
          queryParams.append('courseStatus', params.courseStatus)
        }
        if (params.startDate) queryParams.append('startDate', params.startDate)
        if (params.endDate) queryParams.append('endDate', params.endDate)
        if (params.unit) queryParams.append('unit', params.unit)
        if (params.subunit) queryParams.append('subunit', params.subunit)
        
        const url = `/lms/admin/course/getUserLearningRecords/export${queryParams.toString() ? '?' + queryParams.toString() : ''}`
        
        axios
          .get(url, {
            responseType: 'blob' // Excel dosyası için blob response
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchUserExamQuestions(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/lms/admin/course/getuserexamquestions/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    processUserExam(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/lms/admin/course/processexamquestion', { qid: params.qid, userguid: params.userguid, answerresult: params.answerresult })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    completeuserexam(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/lms/admin/course/completeuserexam', {
            phcode: params.phcode,
            userguid: params.userguid,
            exid: params.exid,
            courseguid: params.courseguid
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
